import { Link } from 'react-router-dom-v5-compat'

import { useSplitEnabled } from '@buffer-mono/features'
import { AudienceIcon, Button } from '@buffer-mono/popcorn'
import {
  BufferTrackerReact as BufferTracker,
  Product,
} from '@buffer-mono/tracking-plan'

import {
  useAccount,
  useCanStartTrial,
  useOrganizationId,
} from '~publish/contexts/AccountContext'
import { isTeamPlan } from '~publish/pages/Settings/util/planUtils'

function TeamMemberInviteUpgradeCTA(): JSX.Element | null {
  const { account } = useAccount()
  const organizationId = useOrganizationId()
  const canStartTrial = useCanStartTrial()
  const isTeam = account && isTeamPlan(account)
  const { isEnabled: isTeamInviteEnabled } = useSplitEnabled(
    'geid-all-channels-invite-team',
  )

  if (!isTeamInviteEnabled) {
    return null
  }

  const cta = 'publish-allChannels-inviteTeam-1'
  const commonTrackingProperties =
    account?.currentOrganization?.commonTrackingProperties || null

  const handleUpgradePathClick = (): void => {
    const { MODALS, actions } = window?.appshell || {}
    if (canStartTrial) {
      actions.openModal(MODALS.startTrial, {
        cta,
        upgradePathName: 'inviteTeam-trial',
      })
    } else {
      actions.openModal(MODALS.planSelector, {
        cta,
        upgradePathName: 'inviteTeam-upgrade',
      })
    }
    BufferTracker.cTAClicked({
      organizationId: organizationId ?? '',
      product: Product.Publish,
      cta,
      clientName: 'publishWeb',
      upgradePathName: `inviteTeam-${canStartTrial ? 'trial' : 'upgrade'}`,
      ...commonTrackingProperties,
    })
  }

  if (isTeam) {
    return (
      <Button variant="secondary" size="medium" as={Link} to="/settings/team">
        <AudienceIcon /> Invite your Team
      </Button>
    )
  }

  return (
    <Button variant="secondary" size="medium" onClick={handleUpgradePathClick}>
      <AudienceIcon /> Invite your Team
    </Button>
  )
}

export default TeamMemberInviteUpgradeCTA
